import React, { useEffect, useState } from 'react'
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Link, TextField } from '@mui/material'
import { ModalProps, ModalPropsBase, TableColumn } from '../../types/widget-types';
import styled from '@emotion/styled';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next'
import { gql, useMutation, useQuery } from '@apollo/client'
import { useDispatch, useSelector } from 'react-redux';
import EllipsisBox from '../../widgets/EllipsisBox/EllipsisBox';
import { splitCamelCase } from '../../utils/util-functions';
import TablePageHoc from '../../hoc/table-list/table-list-hoc';
import { useNavigate } from 'react-router-dom';
import { startPageLoading } from '../../../store/reducers/AppSlice';


const GET_ASSOCIATIONS_QUERY = gql`query GetAllAssociations($clubId: Int, $search: String, $page: Int, $pageSize: Int) {
    getAllAssociations(clubId: $clubId, search: $search, page: $page, pageSize: $pageSize) {
      associations {
        associationName
        id
      }
      errors
      success
      totalAssociations
    }
  }`

const QUERY = `query Query($page: Int, $pageSize: Int, $search: String, $role: [String], $associationId: Int, $clubId: Int) {
    getAllUsers(page: $page, pageSize: $pageSize, search: $search, role: $role, associationId: $associationId, clubId: $clubId) {
      success
      totalUsers
      users {
        Association {
          associationName
        }
        Club {
          clubName
        }
        id
        lastName
        role
        firstName
        email
        contactNumber
        designation
      }
    }
  }`


const CustomDialog = (props: any) => {
    return <Dialog
        {...props}
        className={
            clsx({
                'sizeSmall': props.size == 'sm',
                'sizeLarge': props.size == 'lg',
                'sizeMedium': props.size == 'md',
                'sizeExtraLarge': props.size == 'xl'
            })
        }
    />
}

export interface ClubDetailModalProps extends ModalPropsBase {
    // onConfirm: () => void;
    // children: string;
}

type ChildRef = {
    refetchData: (data: any) => void;
};



function AssociationListModal({ actions, size, modalOpen, onClose, detail }: ClubDetailModalProps) {

    const [associationData, setAssociationData] = useState<any>(null);
    const [requestEventId, setRequestEventId] = useState("");
    const [playersData, setPlayersData] = useState<any>(null);
    const decodedTokenData = useSelector((state: any) => state.auth.decodedTokenData)
    const [page, setPage] = React.useState(1);
    const { refetch: associationFetch } = useQuery(GET_ASSOCIATIONS_QUERY, { skip: true });
    const navigate = useNavigate();
    // const { refetch: usersFetch } = useQuery(GET_USERS_QUERY, { skip: true });
    const dispatch = useDispatch();



    const getPlayerList = gql`query GetPlayerList($clubId: ID, $requestEventId: ID, $associationId: ID, $isSubmitted: Boolean, $search: String, $page: Int, $pageSize: Int) {
        getPlayerList(clubId: $clubId, requestEventId: $requestEventId, associationId: $associationId, isSubmitted: $isSubmitted, search: $search, page: $page, pageSize: $pageSize) {
          errors
          players {
            Association {
                associationName
                id
            }
            Club {
                clubName
                id
            }
            contactPersonName
            RequestEventId
            createdAt
            dateOfBirth
            emailAddressImpFatherOrMother
            lastName
            goalKeeper
            id
            nationality
            playerAddress
            firstName
            postCode
            relationship
            strongFoot
            telephone
            updatedAt
          }
          success
          totalPlayers
        }
      }
      `

    const GET_REQUEST_EVENTS_QUERY = gql`
  query Query {
      getRequestEvents {
        errors
        requestEvents {
          id
          ownerId
        }
        success
      }
    }
  `

    const { refetch: playerRefetch } = useQuery(getPlayerList, { skip: true });
    const { refetch: seasonfetch } = useQuery(GET_REQUEST_EVENTS_QUERY, { skip: true });

    const { associationName, id } = detail


    useEffect(() => {

        if (decodedTokenData.roles !== 'AssociationAdmin' && modalOpen) {
            // getClubData();
            getLatestEvents();
            getAssociationData();
            getPlayersData();
        }
    }, [decodedTokenData, modalOpen])



    const getAssociationData = async () => {

        const { data } = await associationFetch({
            search: "",
            page: null,
            pageSize: null,
            clubId: parseInt(id)
        });
        setAssociationData(data);
        return data;
    }

    const getLatestEvents = async () => {
        const { data } = await seasonfetch({
            search: "",
            page: null,
            pageSize: null
        });

        setRequestEventId(data?.getRequestEvents.requestEvents[0].id)

    }


    const getPlayersData = async () => {

        const { data } = await playerRefetch({
            search: "",
            page: null,
            pageSize: null,
            associationId: parseInt(id)
        });

        setPlayersData(data);
        return data;
    }


    const TableConfig: TableColumn[] = [

        {
            label: "First Name",
            align: "left",
            accessor: (row: any) => <EllipsisBox content={row.firstName} minWidth={250} lineClamp={2} />
        },
        {
            label: "Last Name",
            align: "left",
            accessor: (row: any) => <EllipsisBox content={row.lastName} minWidth={250} lineClamp={2} />
        },
        {
            label: "Email",
            align: "left",
            accessor: (row: any) => row.email
        },
        {
            label: "Contact Number",
            align: "left",
            accessor: (row: any) => row.contactNumber
        },
        {
            label: "Role",
            align: "left",
            accessor: (row: any) => t(splitCamelCase(row.role))
        },
        {
            label: "Club",
            align: "left",
            accessor: (row: any) => row.Club?.clubName
        },
        {
            label: "Association",
            align: "left",
            accessor: (row: any) => row.Association?.associationName
        }
    ]

    const onCloseClick = () => {
        onClose?.()
    }

    const onConfirmClick = () => {
        // onConfirm?.();
        onClose?.();
    }



    const onCloseButtonClick = () => {
        onClose?.()
        dispatch(startPageLoading())
        navigate(`/admin/players-management?season=${requestEventId}&club=${detail.Club?.id}&association=${id}`);

    }



    const { t } = useTranslation();

    return (
        <>
            <CustomDialog
                open={modalOpen ?? false}
                onClose={() => onCloseClick()}
                size='xl'
                sx={{ border: 0 }}

            >
                <DialogTitle variant='h6' color={"primary"}>
                    {t("View Association")}
                </DialogTitle>
                {/* <Divider/> */}
                <DialogContent>
                    <Grid container >
                        <Grid item xs={12} sm={4} md={4}>
                            <DialogContentText sx={{ "fontSize": "12px", "color": "#6b6868" }}>
                                {t("Association Name")}
                            </DialogContentText>
                            <DialogContentText sx={{ "fontSize": "16px", "marginBottom": "10px", "fontWeight": "500" }}>
                                {associationName}
                            </DialogContentText>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <DialogContentText sx={{ "fontSize": "12px", "color": "#6b6868" }}>
                                {t("Club Name")}
                            </DialogContentText>
                            <DialogContentText sx={{ "fontSize": "16px", "marginBottom": "10px", 'fontWeight': "500" }}>
                                {detail.Club?.clubName}
                            </DialogContentText>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <DialogContentText sx={{ "fontSize": "12px", "color": "#6b6868" }}>
                                {t("Submitted Players List")}
                            </DialogContentText>

                            <DialogContentText>
                                <Button autoFocus onClick={onCloseButtonClick} color="primary" style={{ "marginBottom": "10px" }}>
                                    {t('View all')}
                                </Button>
                            </DialogContentText>
                        </Grid>
                    </Grid>

                    <DialogContentText sx={{ "fontSize": "12px", "color": "#6b6868", "marginTop": "10px" }}>
                        {t("Contact Person List")}
                    </DialogContentText>

                    <div style={{ 'marginTop': '20px' }}>
                        <TablePageHoc
                            columns={TableConfig}
                            query={QUERY}
                            params={{
                                // clubId:filterData?.clubId,
                                associationId: parseInt(id)
                            }}
                            sourceAccessor={(data) => data.getAllUsers.users}
                            countAccessor={(data) => data.getAllUsers.totalUsers}
                            pagination={{
                                enable: true,
                                page: page,
                                limit: 5,
                                onChange: (page) => {
                                    setPage(page)
                                }
                            }} /></div>

                    {/* {clubData ? clubData.getOneClub.users.map((user:any)=>(
                        <DialogContentText>- {user.Association?.associationName}</DialogContentText>
                    )):<DialogContentText>{t('Loading')}</DialogContentText>} */}
                </DialogContent>


            </CustomDialog>
        </>
    )
}

export default AssociationListModal